<script>
/**
 * @overview 登陆页面
 *
 * @author  huojinzhao
 */

import { $form, $http, $token } from "@/utils";

export default {
  name: "ViewLogin",

  data: () => ({
    user: {
      name: "",
      password: "",
    },

    rules: {
      name: [
        $form.rules.required("账号"),
        $form.rules.userName,
      ],
      password: [
        $form.rules.required("密码"),
        $form.rules.userPassword,
      ],
    },

    submitLoading: false,

    submitError: {},
  }),

  methods: {
    toggleSubmitLoading() {
      this.submitLoading = !this.submitLoading;
    },

    submitBefore() {
      console.log(`登录操作window.location.hostname:${window.location.hostname}`);
      console.log(this.user);

      this.$refs.form.validate((valid) => {
        console.log(valid);

        if (valid) this.submit();
      });
    },

    submit() {
      this.toggleSubmitLoading();
      console.log("submit");
      $http.post("/user/login", this.user)
        .then(this.submitSucceed)
        .catch(this.submitFailure)
        .finally(this.toggleSubmitLoading);
    },

    submitSucceed({ access_token: token }) {
      console.log(`submitSucceed:---${token}`);
      const baseHeaders = {
        Authorization: `Bearer ${token}`,
      };

      $http.init({ baseHeaders });

      $token.set(token);

      window.location.href = "/";
    },

    submitFailure(error) {
      this.submitError = error;
    },
  },
};
</script>

<template>
  <main class="layout-screen view-login">
    <div
      class="view-login__panel"
    >
      <header>imkid课件管理平台</header>

      <el-form
        ref="form"
        :model="user"
        :rules="rules"
        class="view-login__form"
        @keydown.enter.native="submitBefore"
      >
        <el-form-item prop="name">
          <el-input
            v-model="user.name"
          >
            <i
              slot="prepend"
              class="iconfont icon-user"
            />
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="user.password"
            type="password"
          >
            <i
              slot="prepend"
              class="iconfont icon-lock"
            />
          </el-input>
        </el-form-item>
      </el-form>

      <AppFormAlert
        :contents="submitError"
      />

      <el-button
        :loading="submitLoading"
        type="primary"
        @click="submitBefore"
      >
        登录
      </el-button>
    </div>
  </main>
</template>

<style lang="postcss">
.view-login {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('/login-bg.png');
  background-position: center;
  background-size: cover;
}

.view-login__panel {
  display: flex;
  flex-flow: column nowrap;
  padding: 42px 38px 38px 38px;
  width: 420px;
  background-color: rgba(0, 0, 0, .6);
  border-radius: var(--bd-radius);
  color: white;
}

.view-login__panel > header {
  text-align: center;
  font-size: 2em;
  margin-bottom: 1em;
}

.view-login__panel .iconfont {
  font-size: 22px;
}

.view-login__panel .el-input-group__prepend {
  padding: 0 12px;
}
</style>
